export default __webpack_public_path__ + "static/nanno_screen_1-29edbdcf4b79430921e9b5d89ac5708a.svg";